import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/iconite/home.png'
import _imports_1 from '@/assets/iconite/search.png'
import _imports_2 from '@/assets/iconite/dorinte.png'
import _imports_3 from '@/assets/menu_icons/Cereri_si_Oferte.png'
import _imports_4 from '@/assets/menu_icons/Facturi.png'
import _imports_5 from '@/assets/menu_icons/Alerte.png'
import _imports_6 from '@/assets/menu_icons/Date_companie.png'
import _imports_7 from '@/assets/menu_icons/Utilizatori.png'
import _imports_8 from '@/assets/iconite/locatie.png'
import _imports_9 from '@/assets/iconite/phone.png'
import _imports_10 from '@/assets/iconite/mesaj.png'


const _withScopeId = n => (_pushScopeId("data-v-e5d9c116"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "q-pa-lg ecran-container" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Alerta aveti facturi depasite ")
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "click aici pentru vizualizare", -1))
const _hoisted_4 = {
  key: 1,
  class: "app__page__title__container"
}
const _hoisted_5 = { style: {"white-space":"nowrap","font-size":"2.3rem"} }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"position":"relative","margin-right":"4px","width":"24px","height":"24px"}
}, null, -1))
const _hoisted_7 = { class: "dashboard__section" }
const _hoisted_8 = { class: "dashboard__div__title" }
const _hoisted_9 = { class: "dashboard__div__content" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  style: {"position":"relative","zoom":"0.75","margin-right":"4px","width":"24px","height":"24px"}
}, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  style: {"position":"relative","zoom":"0.7","width":"28px","height":"24px","margin-right":"4px"}
}, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  style: {"position":"relative","margin-right":"4px","width":"24px","height":"24px","zoom":"0.8"}
}, null, -1))
const _hoisted_13 = { class: "dashboard__section" }
const _hoisted_14 = { class: "dashboard__div__title" }
const _hoisted_15 = { class: "dashboard__div__content" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  style: {"position":"relative","margin-right":"4px","width":"24px","height":"24px","zoom":"0.8"}
}, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  style: {"position":"relative","width":"28px","height":"30px","zoom":"0.75","margin-right":"4px"}
}, null, -1))
const _hoisted_18 = { class: "dashboard__section" }
const _hoisted_19 = { class: "dashboard__div__title" }
const _hoisted_20 = { class: "dashboard__div__content" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  style: {"width":"24px","height":"24px","margin-right":"4px","zoom":"0.9"}
}, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  style: {"position":"relative","zoom":"0.9","margin-right":"4px","width":"28px","height":"24px"}
}, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_8,
  style: {"position":"relative","zoom":"0.6","width":"28px","height":"36px","margin-right":"4px"}
}, null, -1))
const _hoisted_24 = { class: "dashboard__section" }
const _hoisted_25 = { class: "dashboard__div__title" }
const _hoisted_26 = { class: "dashboard__div__content" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_9,
  style: {"position":"relative","zoom":"0.6","width":"36px","height":"36px","margin-right":"4px"}
}, null, -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_10,
  style: {"position":"relative","zoom":"0.6","width":"36px","height":"36px","margin-right":"4px"}
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_banner = _resolveComponent("q-banner")!
  const _component_q_badge = _resolveComponent("q-badge")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showAlertDepasireTermenFacturi)
      ? (_openBlock(), _createBlock(_component_q_banner, {
          key: 0,
          dense: "",
          "inline-actions": "",
          class: "text-white bg-red q-ma-md",
          style: {"width":"100%","margin":"0 auto","cursor":"pointer"},
          onClick: _ctx.onGoFacturi
        }, {
          action: _withCtx(() => [
            _createVNode(_component_q_icon, {
              color: "white",
              name: "close",
              onClick: _ctx.closeAlertDepasireTermenFacturi,
              style: {"cursor":"pointer"}
            }, null, 8, ["onClick"])
          ]),
          default: _withCtx(() => [
            _hoisted_2,
            _hoisted_3
          ]),
          _: 1
        }, 8, ["onClick"]))
      : _createCommentVNode("", true),
    (_ctx.$q.platform.is.desktop)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createTextVNode(" " + _toDisplayString(_ctx.$t('message.main_page')), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('message.activity')), 1),
      _createElementVNode("div", _hoisted_9, [
        _withDirectives(_createElementVNode("div", {
          class: "dashboard__div__parameter",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onGoCautaArticole && _ctx.onGoCautaArticole(...args)))
        }, [
          _hoisted_10,
          _createTextVNode(" " + _toDisplayString(_ctx.$t('message.search_items')), 1)
        ], 512), [
          [_directive_ripple]
        ]),
        _withDirectives(_createElementVNode("div", {
          class: "dashboard__div__parameter",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onGoArticoleFavorite && _ctx.onGoArticoleFavorite(...args)))
        }, [
          _hoisted_11,
          _createTextVNode(" " + _toDisplayString(_ctx.$t('message.favorite_items')), 1)
        ], 512), [
          [_directive_ripple]
        ]),
        _withDirectives(_createElementVNode("div", {
          class: "dashboard__div__parameter",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onGoToOffers && _ctx.onGoToOffers(...args)))
        }, [
          _hoisted_12,
          _createTextVNode(" " + _toDisplayString(_ctx.$t('message.offers')) + " ", 1),
          (_ctx.userStore.countOferte>0)
            ? (_openBlock(), _createBlock(_component_q_badge, {
                key: 0,
                color: "red",
                class: "badge__superscript--top",
                style: {"height":"1rem","margin-left":"8px"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.userStore.countOferte), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ], 512), [
          [_directive_ripple]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('message.financial_data')), 1),
      _createElementVNode("div", _hoisted_15, [
        _withDirectives(_createElementVNode("div", {
          class: "dashboard__div__parameter",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onGoFacturi && _ctx.onGoFacturi(...args)))
        }, [
          _hoisted_16,
          _createTextVNode(" " + _toDisplayString(_ctx.$t('message.invoices')), 1)
        ], 512), [
          [_directive_ripple]
        ]),
        _withDirectives(_createElementVNode("div", {
          class: "dashboard__div__parameter",
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onGoAlerte && _ctx.onGoAlerte(...args)))
        }, [
          _hoisted_17,
          _createTextVNode(" " + _toDisplayString(_ctx.$t('message.alerts')) + " ", 1),
          (_ctx.userStore.user.slid > 0)
            ? (_openBlock(), _createBlock(_component_q_badge, {
                key: 0,
                color: "red",
                transparent: "",
                class: "badge__superscript--top",
                style: {"height":"1rem","margin-left":"8px"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.userStore.user.slid), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ], 512), [
          [_directive_ripple]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('message.my_account')), 1),
      _createElementVNode("div", _hoisted_20, [
        _withDirectives(_createElementVNode("div", {
          class: "dashboard__div__parameter",
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onGoDateCompanie && _ctx.onGoDateCompanie(...args)))
        }, [
          _hoisted_21,
          _createTextVNode(" " + _toDisplayString(_ctx.$t('message.company_data')), 1)
        ], 512), [
          [_directive_ripple]
        ]),
        _withDirectives(_createElementVNode("div", {
          class: "dashboard__div__parameter",
          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onGoUsersCompany && _ctx.onGoUsersCompany(...args)))
        }, [
          _hoisted_22,
          _createTextVNode(" " + _toDisplayString(_ctx.$t('message.users')), 1)
        ], 512), [
          [_directive_ripple]
        ]),
        _withDirectives(_createElementVNode("div", {
          class: "dashboard__div__parameter",
          onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onGoNomAdreseLivrare && _ctx.onGoNomAdreseLivrare(...args)))
        }, [
          _hoisted_23,
          _createTextVNode(" " + _toDisplayString(_ctx.$t('message.delivery_addresses')) + " ", 1),
          (_ctx.userStore.countAdrese>0)
            ? (_openBlock(), _createBlock(_component_q_badge, {
                key: 0,
                color: "red",
                class: "badge__superscript--top",
                style: {"height":"1rem","margin-left":"8px"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.userStore.countAdrese), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ], 512), [
          [_directive_ripple]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$t('message.info_util')), 1),
      _createElementVNode("div", _hoisted_26, [
        _withDirectives(_createElementVNode("div", {
          class: "dashboard__div__parameter",
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.openLink('https://melindasteel.hu/kapcsolat')))
        }, [
          _hoisted_27,
          _createTextVNode(" " + _toDisplayString(_ctx.$t('message.service_center')), 1)
        ], 512), [
          [_directive_ripple]
        ]),
        _withDirectives(_createElementVNode("div", {
          class: "dashboard__div__parameter",
          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.openContact()))
        }, [
          _hoisted_28,
          _createTextVNode(" " + _toDisplayString(_ctx.$t('message.contact_form')), 1)
        ], 512), [
          [_directive_ripple]
        ])
      ])
    ])
  ]))
}